export default "__VITE_ASSET__D5P2kCOu__"